import React from "react";
import Navbar from "../components/navbar";
import "../css/App.css"

const NotFoundPage = () => {
    return (
        <div><Navbar /> <div className="not-found-page" style={styles.page}>

            <div className="not-found-content" style={styles.content}>
                <h1 style={styles.code}>404</h1>
                <h2 style={styles.message}>This page is anathema.</h2>
                <p style={styles.subtext}>
                    Either you've stumbled into heresy, or the page you’re looking for has been excommunicated.
                </p>
                <div className="halo-animation" style={styles.halo}></div>
                <a href="/" style={styles.button}>Back to Safety</a>
            </div>
        </div></div>

    );
};

const styles = {
    page: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "90vh",
        background: "radial-gradient(circle at 50% -10%, #ffffff 0, #f2e8d3 55%, #ece0c6 100%)",
        position: "relative",
        overflow: "hidden",
        textAlign: "center",
    },
    content: {
        maxWidth: "600px",
        padding: "2.5rem 2rem",
        backgroundColor: "#ffffff",
        border: "1px solid #c08d3b",
        borderRadius: "4px",
        boxShadow: "0 10px 26px rgba(13, 46, 78, 0.12)",
        zIndex: 10,
    },
    code: {
        fontSize: "6rem",
        fontWeight: "bold",
        color: "#0f3650",
    },
    message: {
        fontSize: "2rem",
        marginBottom: "1rem",
        color: "#0f3650",
    },
    subtext: {
        fontSize: "1.2rem",
        marginBottom: "2rem",
        color: "#4a4436",
    },
    button: {
        padding: "0.8rem 1.5rem",
        backgroundColor: "#f1b249",
        color: "#0f3650",
        border: "1px solid #c08d3b",
        borderRadius: "4px",
        textDecoration: "none",
        fontWeight: "bold",
    },
    halo: {
        position: "absolute",
        top: "-90px",
        right: "-90px",
        width: "200px",
        height: "200px",
        background: "radial-gradient(circle, rgba(241, 178, 73, 0.28), transparent 70%)",
        borderRadius: "50%",
        animation: "pulse 4s infinite ease-in-out",
    },
};

export default NotFoundPage;
